let clarityLoaded = false;
let googleAnalyticsLoaded = false;

const CLARITY_ID = process.env.REACT_APP_CLARITY_ID;
const GA_ID = process.env.REACT_APP_GA_ID;

export function initClarity() {
  if (!CLARITY_ID || clarityLoaded) return;
  if (typeof window === "undefined" || typeof document === "undefined") return;

  (function (c, l, a, r, i, t, y) {
    c[a] =
      c[a] ||
      function () {
        (c[a].q = c[a].q || []).push(arguments);
      };

    t = l.createElement(r);
    t.async = 1;
    t.src = "https://www.clarity.ms/tag/" + i;

    y = l.getElementsByTagName(r)[0];
    y.parentNode.insertBefore(t, y);
  })(window, document, "clarity", "script", CLARITY_ID);

  clarityLoaded = true;
}

export function initGoogleAnalytics() {
  if (!GA_ID || googleAnalyticsLoaded) return;
  if (typeof window === "undefined" || typeof document === "undefined") return;

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;

  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];

  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };

  window.gtag("js", new Date());

  window.gtag("config", GA_ID, {
    page_path: window.location.pathname + window.location.search + window.location.hash,
  });

  googleAnalyticsLoaded = true;
}

export function initAnalytics() {
  initClarity();
  initGoogleAnalytics();
}

export function trackPageView(path) {
  if (!GA_ID) return;
  if (typeof window === "undefined") return;
  if (typeof window.gtag !== "function") return;

  window.gtag("config", GA_ID, {
    page_path: path || window.location.pathname + window.location.search + window.location.hash,
  });
}

export function trackEvent(action, params = {}) {
  if (!GA_ID) return;
  if (typeof window === "undefined") return;
  if (typeof window.gtag !== "function") return;

  window.gtag("event", action, params);
}